import { useQuery } from "@tanstack/react-query";

import { useApi } from "../../useApi";

import { IInvoiceInfos } from "@/components/Contracts/components/Invoice/interfaces";

export const useGetPaymentConditions = ({
  contractId,
  enabled,
  staleTime
}: {
  contractId: number;
  enabled?: boolean;
  staleTime?: number;
}) => {
  const { execute } = useApi();

  return useQuery({
    queryKey: ["payment-conditions", contractId],
    enabled,
    staleTime,
    queryFn: async (): Promise<IInvoiceInfos> => {
      const data = await execute({
        url: `contracts/${contractId}/payment-conditions`
      });

      return data.data;
    }
  });
};
